import { render, staticRenderFns } from "./CartPageItem.vue?vue&type=template&id=5012ff3b&scoped=true"
import script from "./CartPageItem.vue?vue&type=script&lang=js"
export * from "./CartPageItem.vue?vue&type=script&lang=js"
import style0 from "./CartPageItem.vue?vue&type=style&index=0&id=5012ff3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5012ff3b",
  null
  
)

export default component.exports